module.exports = __webpack_public_path__ + "static/media/Screenshot_3.8a673df9.png";